import { render } from "./AccountRecovery.vue?vue&type=template&id=21e8ab23&scoped=true"
import script from "./AccountRecovery.vue?vue&type=script&lang=js"
export * from "./AccountRecovery.vue?vue&type=script&lang=js"

import "./AccountRecovery.vue?vue&type=style&index=0&id=21e8ab23&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e8ab23"]])

export default __exports__